// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-form {\n  margin: 1rem 0;\n}\n", "",{"version":3,"sources":["webpack://./src/modules/Tasks/components/SearchForm/SearchForm.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB","sourcesContent":[".search-form {\n  margin: 1rem 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
